export async function copy_to_clipboard(text){
    try {
        await navigator.clipboard.writeText(text);
        return true;
    }
    catch(err){
        return false;
    }
}
